'use client';

import { useState, useRef } from 'react';

import Image from '@src/components/atoms/safe-image';
import { usePathname } from 'next/navigation';

// Assets
import Hamburger from '@public/svg/i-hamburger.jsx';
import Century21 from '@public/png/century-21-black-1.png';
import IBeranda from '@public/svg/i-beranda2';
import IProperti from '@public/svg/i-properti2';
import IX from '@public/svg/i-x';
import IArrowRight from '@public/svg/i-arrow-right';

// Hooks
import useRedirect from '@src/hooks/useRedirect';
import useOutsideAlerter from '@src/hooks/useOutsideAlerter';

const TABS = [
  {
    label: 'Beranda',
    pathname: '/marketing/:id',
    icon: <IBeranda />,
  },
  {
    label: 'Properti',
    pathname: '/marketing/:id/list-listing',
    icon: <IProperti />,
  },
];

const NavbarMobile = ({
  className,
  handleScrollToListProperty,
  handleScrollToProfile,
  onlineProfile,
  id,
}) => {
  const ref = useRef(null);
  const redirect = useRedirect();
  const currentPath = usePathname();
  const [isOpen, setIsOpen] = useState(false);

  const username = onlineProfile?.data?.data?.username || 'century21hq2';

  const isBerandaTab = currentPath.includes(`marketing/${username}`) && !currentPath.includes('detail-listing');
  const isDetailListingPage = currentPath.includes('detail-listing');

  const handleToHomepage = () => {
    redirect(`/marketing/${username}`);
  };

  const handleCloseDropdown = () => {
    setIsOpen(false);
  };

  const handleRedirect = (tab) => {
    handleCloseDropdown();

    if (isBerandaTab && tab.label === 'Beranda') {
      handleScrollToProfile();
      return;
    }

    if (isBerandaTab && tab.label === 'Properti') {
      handleScrollToListProperty();
      return;
    }

    if (isDetailListingPage && tab.label === 'Properti') {
      redirect(`/marketing/${username}#list-property`);
      return;
    }

    redirect(tab.pathname.replace(':id', username));
  };

  useOutsideAlerter(ref, handleCloseDropdown);
  return (
    <div
      className={`section-container justify-center relative bg-[#FAFAFA] border-b-[0.5px] border-solid border-[#E6E7E8] ${className}`}
    >
      <div className="px-[24px] py-[16px] w-full flex items-center gap-4 justify-between">
        <div className="flex items-center justify-between w-full gap-4">
          <div
            className="cursor-pointer flex flex-col"
            onClick={handleToHomepage}
          >
            <Image
              src={Century21}
              alt="CENTURY 21"
              width="auto"
              height="auto"
              className="cursor-pointer object-contain w-[102.797px] h-[24px]"
            />
            <p className="text-[12px] text-[#252526] font-satoshi-medium">
              {onlineProfile?.data?.data?.office_name || 'Century 21'}
            </p>
          </div>
          <button onClick={() => setIsOpen(!isOpen)}>
            <Hamburger />
          </button>
        </div>
      </div>

      {isOpen && (
        <>
          <div className="fixed inset-0 top-0 bg-black/30 backdrop-blur-sm z-[5]"></div>
          <div
            className="absolute top-0 bg-white rounded-b-[8px] shadow-[0_2px_24px_0_rgba(4,7,4,0.08)] left-0 z-10 w-full"
            ref={ref}
          >
            <div className="flex flex-col">
              <div className="px-6 py-4 flex items-center justify-between bg-white">
                <button
                  className="cursor-pointer w-[24px] h-[24px]"
                  onClick={handleCloseDropdown}
                >
                  <IX width="24px" height="24px" />
                </button>
              </div>
              {TABS.map((tab, index) => {
                const isActive =
                  currentPath ===
                  tab.pathname
                    .replace(':id', username);

                return (
                  <div key={`menu-item-${index}`}>
                    <div
                      className={`px-6 py-4 flex items-center justify-between text-[17px]/[23.8px] tracking-[0.17px] ${
                        isActive
                          ? 'bg-[#040704] text-white'
                          : 'border-b-[1px] border-dashed border-[#E6E7E8] font-satoshi text-[#040704]'
                      } ${index === TABS.length - 1 ? 'rounded-b-[8px]' : ''}`}
                      onClick={() => handleRedirect(tab)}
                    >
                      <span>{tab.label}</span>
                      {!isActive ? (
                        <button className="cursor-pointer w-4 h-4 rounded-[4px] bg-[#F5F5F5] flex items-center justify-center">
                          <IArrowRight
                            width="8px"
                            height="8px"
                            color="#686A68"
                          />
                        </button>
                      ) : null}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default NavbarMobile;
